import type { onBeforeSaveType, onAfterSaveType } from 'app/main/components/hooks/useModel';
import { executeStored, getCoordinates } from 'app/main/components/Utils';
import { sendNotification } from 'app/store/notifications/notificationsHubSlice';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';
import { openCompaniesDuplicateAlertDialog } from './components/CompaniesDuplicateAlertDialog';

const duplicatesCheck: onBeforeSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		const vatNumber = modifiedModel.comp_vatnumber;

		if (vatNumber) {
			return executeStored({
				action: 'st_companies_list',
				dispatch,
				params: {
					n_page: 1,
					n_rows: 100,
					filters: [
						{ filt_field: 'comp_deleted', filt_clause: 'not_equal', filt_value: 1 },
						{ filt_field: 'comp_uid', filt_clause: 'not_equal', filt_value: model.comp_uid },
						{ filt_field: 'comp_vatnumber', filt_clause: 'equals', filt_value: vatNumber }
					]
				}
			}).then(response => {
				const duplicateCompanies = response.data.list;
				if (!duplicateCompanies || duplicateCompanies?.length === 0) resolve();
				else
					dispatch(
						openCompaniesDuplicateAlertDialog({
							duplicateCompanies,
							onSave: () => resolve(),
							onCancel: () => reject()
						})
					);
			});
		} else resolve();
	});

const updateCoordinates: onBeforeSaveType = ({ dispatch, model, modifiedModel, sysSettings }) =>
	new Promise<any>((resolve, reject) => {
		if (
			modifiedModel.comp_address ||
			modifiedModel.comp_city ||
			modifiedModel.comp_zip ||
			modifiedModel.dist_title ||
			modifiedModel.ctry_title
		) {
			const coordinatesPromise = getCoordinates({
				address: {
					address: modifiedModel.comp_address || model.comp_address,
					city: modifiedModel.comp_city || model.comp_city,
					zip: modifiedModel.comp_zip || model.comp_zip,
					district: modifiedModel.dist_title || model.dist_title,
					country: modifiedModel.ctry_title || model.ctry_title
				},
				dispatch,
				sysSettings
			});

			if (coordinatesPromise)
				return coordinatesPromise.then(response =>
					resolve({ comp_lat: response.data.lat, comp_lng: response.data.lng })
				);
		}

		resolve(undefined);
	});

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (modifiedModel.comp_user_assigned_uid !== model.comp_user_modified_uid) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.comp_user_modified_uid,
						assignedTo: modifiedModel.comp_user_assigned_uid,
						title: 'Nuova Azienda assegnata',
						body: `${model.user_modified_title} ti ha assegnato a "${model.comp_title}".`,
						url: `${window.location.origin}/companies/details/${model.comp_uid}`,
						icon: 'domain',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const onBeforeSave: onAfterSaveType = params => DetailsEventsWrapper(params)([duplicatesCheck, updateCoordinates]);

const onAfterSave: onAfterSaveType = params => DetailsEventsWrapper(params)([sendSaveNotification]);

export default { onBeforeSave, onAfterSave };
